import cx from "classnames"
import * as React from "react"

import { FlowQuestionId, LearnMoreTileSize } from "types"
import * as styles from "./styles.module.scss"

export interface LearnMoreItemProps {
  itemKey: string
  tile: React.ReactNode
  trigger: FlowQuestionId
  size: LearnMoreTileSize
  userAnswers: any
}

const LearnMoreItem: React.FC<LearnMoreItemProps> = ({
  itemKey,
  tile,
  trigger,
  size,
  userAnswers,
}) => {
  console.log(size)
  return (
    <li
      className={cx({
        [styles.item]: true,
        [styles.large]: size === LearnMoreTileSize.Large,
        [styles.medium]: size === LearnMoreTileSize.Medium,
        [styles.small]: size === LearnMoreTileSize.Small,
        [styles.option]: true,
        [styles.show]: itemKey.indexOf(userAnswers[trigger]?.value) !== -1,
      })}
    >
      {tile}
    </li>
  )
}

export default LearnMoreItem
